import { render } from "./ResumeSection.vue?vue&type=template&id=0dc62e72&scoped=true"
import script from "./ResumeSection.vue?vue&type=script&lang=js"
export * from "./ResumeSection.vue?vue&type=script&lang=js"

import "./ResumeSection.vue?vue&type=style&index=0&id=0dc62e72&scoped=true&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc62e72"]])

export default __exports__